import React, { useState } from "react"; 
import { useConfirm } from "material-ui-confirm";
import { useSnackbar } from "notistack";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import { Button } from "react-bootstrap";
import { TextField } from "@mui/material";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";

const EventoLogisticoOperacoesPopup = (props: any) => {
    const [operacaoBusca, setOperacaoBusca] = useState('');
    const [operacaoGrupoBusca, setOperacaoGrupoBusca] = useState('');
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState<number>(20);
    const [responseRows, setResponseRows] = useState<any>({});

    const confirm = useConfirm();
    const { enqueueSnackbar } = useSnackbar();

    const columns: any[] = [
        { dataIndex: 'operacao_nome', title: 'Operação', minWidth: 200, flex: 0.4, },
        { dataIndex: 'operacao_permissao_grupo_nome', title: 'Grupo', minWidth: 200, flex: 0.4, },
    ];

    async function saveAsync() {
        try {
            await axios.post('painelEventoLogisticoUsuarioOperacoes', {'ids': selectedRows});

            enqueueSnackbar('Salvo com sucesso!', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', { variant: 'error' });
        }
        finally {
            document.body.style.cursor = "default";
        }
    }

    async function buscar()
    {
        enqueueSnackbar("Seleção de operações reiniciadas", {variant: 'info'});
        await atualizaListaBuscaCallBack(pageSize, 1);
    }

    const atualizaListaBuscaCallBack: any = async (pageSize: number, pageNumber: number) => {
        try {
            document.body.style.cursor = "progress";
            setPageSize(pageSize);
            let response = await axios.get(`painelEventoLogisticoUsuarioOperacoes?page=${pageNumber}&pageSize=${pageSize}&operacao_nome=${operacaoBusca}&operacao_permissao_grupo_nome=${operacaoGrupoBusca}`);
            setResponseRows(response);
        } catch (error) {
          console.log(error);
        }
        finally{
          document.body.style.cursor = "default";
        }
      }

    return (
        <BasePopup title="Operações Painel Eventos Logísticos" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={saveAsync} isPesquisa='false' confirmClose={true}>
            <span>
                <TextField
                    label="Operação"
                    variant="outlined"
                    className="col-5"
                    value={operacaoBusca}
                    onChange={(event: any) => setOperacaoBusca(event.target.value)}
                    style={{ paddingRight: 10 }} />

                <TextField
                    label="Grupo"
                    variant="outlined"
                    className="col-5"
                    value={operacaoGrupoBusca}
                    onChange={(event: any) => setOperacaoGrupoBusca(event.target.value)}
                    style={{ paddingRight: 10 }} />

                <Button
                    onClick={buscar}
                    style={{ marginTop: 15 }}
                    variant="contained"
                    className="col-2">
                    Buscar
                </Button>
            </span>

            <DataGridComponent
                heightFix={230}
                responseRows={responseRows}
                hideButtons={true}
                columns={columns}
                paginationSide='client'
                checkboxSelection
                checkboxKeyField='visivel_painel_evento_logistico'
                setSelectedRows={setSelectedRows}
                rowsPerPageOptions={[100, 50, 20]}
                atualizaListaBuscaCallBack={atualizaListaBuscaCallBack} />
        </BasePopup>
    );
}

export default EventoLogisticoOperacoesPopup;

